// extracted by mini-css-extract-plugin
export default {"root":"jYQ_ML2"};